var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide bg-cover bg-center",style:(_vm.style)},[_c('div',{staticClass:"lg:relative bg-black bg-opacity-25"},[_c('div',{staticClass:"mx-auto max-w-7xl w-full text-center"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }